import { createContext } from 'react';

const clientView = 'client';
const advisorView = 'advisor';
const unknownView = 'unknown';

const ViewContext = createContext(unknownView);

export default ViewContext;

export { clientView, advisorView, unknownView };
